export enum VisitCheckinErrors {
  blockedList = 'BlockedListed',
  uniqueVisit = 'uniqueVisit',
  allowList = 'AllowListed',
}
